export var HTMLElementPropertyUnit;
(function (HTMLElementPropertyUnit) {
    HTMLElementPropertyUnit["Em"] = "em";
    HTMLElementPropertyUnit["Percent"] = "%";
    HTMLElementPropertyUnit["Pixel"] = "px";
    HTMLElementPropertyUnit["Point"] = "pt";
})(HTMLElementPropertyUnit || (HTMLElementPropertyUnit = {}));
//# sourceMappingURL=HTMLElementPropertyUnit.js.map